<template>
  <div id="top">
    <headNav :gray="gray"></headNav>
    <!--container-->
    <div class="innerWrapper">
      <div class="home"></div>
      <h1>Complete</h1>
      <h4 style="padding:0 .26rem;box-sizing: border-box;">
        You have Successfuly reserved the following property for your client.
      </h4>
      <p style="padding:0 .26rem;box-sizing: border-box;">
        We will shortly send through an email containing the contract for this
        property and a Unifi employee will be in touch with you.
      </p>
      <div class="info">
        <div class="top">${{ item.price }}</div>
        <h2>{{ item.proertyType }}</h2>
        <h3>
          <i v-if="item.apt" style="font-style:normal">{{ item.apt }} / </i
          >{{ item.address }} {{ item.suburb }}
        </h3>
        <h6>{{ item.state }} {{ item.postcode }}</h6>
        <div class="dtl">
          <p>
            <span>Estimated commencement</span
            ><span>{{ item.estimatedCommenceMent }}</span>
          </p>
          <p>
            <span>Estimated completion</span
            ><span>{{ item.estimatedCompletion }}</span>
          </p>
          <p>
            <span>Estimated rental<br />(per week)</span>
            <span style="margin-top:.05rem">
              ${{ item.rental }}
              <i
                v-if="
                  item.maxRental &&
                    item.maxRental !== '' &&
                    item.maxRental !== 0 &&
                    item.maxRental !== '0'
                "
                style="font-style:normal;display:block;line-height:.2rem;float:none;text-align:left"
              >
                -
              </i>
              <i
                v-if="
                  item.maxRental &&
                    item.maxRental !== '' &&
                    item.maxRental !== 0 &&
                    item.maxRental !== '0'
                "
                style="font-style:normal;display:block;float:none;text-align:left"
                >${{ item.maxRental }}</i
              >
            </span>
          </p>
          <p v-if="item.proertyType === 'House & Land'">
            <span>Land price</span><span>${{ item.landPrice }}</span>
          </p>
          <p v-if="item.proertyType === 'House & Land'">
            <span>Build price</span><span>${{ item.buildPrice }}</span>
          </p>
          <p>
            <span>Rental yield</span><span>{{ item.rentalYield }}%</span>
          </p>
          <p><span>Incentives</span><span v-html="item.incentives"></span></p>
        </div>
      </div>
      <button @click="back">Done</button>
    </div>
    <!--footer-->
    <foot-nav></foot-nav>
  </div>
</template>

<script>
import headNav from "@/components/package/nav";
import footNav from "@/components/package/footer";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      item: {},
      disable: false,
      gray: true,
      pm: {}
    };
  },
  created() {
    var that = this;
    if (!that.$route.params.id) {
      that.$router.push("/");
      return;
    }
    that.pm = that.$route.params;
    that.getPropertyDtl({
      params: { id: that.$route.params.id, roomId: that.$route.params.roomId },
      callback: that.callback
    });
  },
  mounted() {
    document.getElementById("top").scrollIntoView();
  },
  methods: {
    ...mapActions("property", ["getPropertyDtl"]),
    // 获取房产详情的回调
    callback(res) {
      var that = this;
      if (res.data.code == 0) {
        var datum = res.data.data;
        if (datum.imageUrl.indexOf(",") !== -1) {
          datum.imgLst = datum.imageUrl.split(",");
        } else {
          datum.imgLst = [datum.imageUrl];
        }
        datum.rental = that.$box.formatSplit(datum.rental, true);
        datum.commision = that.$box.formatSplit(
          parseInt(datum.commision),
          true
        );
        datum.price = that.$box.formatSplit(datum.price, true);
        datum.maxCommision =
          datum.maxCommision !== ""
            ? that.$box.formatSplit(parseInt(datum.maxCommision), true)
            : "";
        datum.maxPrice =
          datum.maxPrice !== ""
            ? that.$box.formatSplit(datum.maxPrice, true)
            : "";

        datum.landPrice =
          datum.landPrice !== ""
            ? that.$box.formatSplit(datum.landPrice, true)
            : "";
        datum.buildPrice =
          datum.buildPrice !== ""
            ? that.$box.formatSplit(datum.buildPrice, true)
            : "";

        datum.maxRental =
          datum.maxRental !== 0
            ? that.$box.formatSplit(datum.maxRental, true)
            : null;
        that.item = datum;
      } else if (
        res.data.code == 90000 ||
        res.data.code == 90002 ||
        res.data.code == 8902 ||
        res.data.code == 8901
      ) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      }
    },
    back() {
      this.$router.push("/");
    }
  },
  components: {
    headNav,
    footNav
  }
};
</script>

<style lang="scss" scoped>
.innerWrapper {
  width: 100%;
  padding: 1.66rem 0.24rem 0 0.24rem;
  box-sizing: border-box;

  .top {
    font-size: 16px;
    margin-bottom: 1px;
    text-align: right;
    color: #3f3f46;
  }

  .home {
    width: 1.16rem;
    height: 1.05rem;
    margin: 0 auto 0.34rem auto;
    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;
    background-image: url("../../../assets/home.png");
  }

  h1 {
    font-size: 0.48rem;
    line-height: 0.58rem;
    margin-bottom: 0.32rem;
    color: #3f3f46;
    text-align: center;
    font-family: ProximaNova-Semibold;
  }

  h4 {
    font-size: 0.32rem;
    line-height: 0.48rem;
    color: #3f3f46;
    margin-bottom: 0.32rem;
    text-align: center;
  }

  p {
    font-size: 0.28rem;
    line-height: 0.42rem;
    margin-bottom: 0.64rem;
    color: #aeabb0;
    text-align: center;
  }

  .info {
    width: 100%;
    box-sizing: border-box;
    padding: 0.4rem 0.32rem 0.48rem 0.32rem;
    border-radius: 0.04rem;
    border: 1px solid #e2e0e3;
    margin-bottom: 0.64rem;

    h1 {
      font-size: 0.32rem;
      line-height: 0.38rem;
      text-align: right;
      color: #3f3f46;
    }

    h2 {
      color: #979497;
      font-size: 0.24rem;
      line-height: 0.28rem;
      margin-top: -0.1rem;
      margin-bottom: 0.24rem;
    }

    h3 {
      font-size: 0.52rem;
      line-height: 0.62rem;
      color: #3f3f46;
      margin-bottom: 0.12rem;
    }

    h6 {
      font-size: 0.4rem;
      color: #979497;
      margin: 0 0 0.32rem;
      text-align: left;
      padding: 0;
    }

    .dtl {
      width: 100%;
      position: relative;
      padding: 0.06rem 0;
      margin-bottom: 0.22rem;

      p {
        font-size: 0.28rem;
        color: #979497;
        margin-bottom: 0.1rem;
        display: flex;
        flex-direction: row;

        span:nth-child(1) {
          flex: 0 0 auto;
          width: 3.2rem;
          text-align: right;
          vertical-align: top;
          margin-right: 0.35rem;
        }

        span:nth-child(2) {
          flex: 1;
          color: #3f3f46;
          display: inline-block;
          word-break: break-word;
          text-align: left;
        }
      }

      p:nth-last-child(1) {
        margin: 0;
      }
    }

    .dtl:after {
      content: "";
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 0.1rem;
      height: 2.3rem;
      background: rgba(255, 239, 0, 1);
    }
  }

  button {
    display: block;
    margin: 0 auto 0.8rem auto;
    width: 5.58rem;
    height: 0.92rem;
    box-sizing: border-box;
    border-radius: 0.12rem;
    border: 1px solid rgba(44, 202, 115, 1);
    font-size: 0.3rem;
    background: #fff;
    color: #2cca73;
    cursor: pointer;
    font-family: ProximaNova-Semibold;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/details/property/complete.vue